export default __webpack_public_path__ + "static/media/xVOLT.38838e9e.svg";